import { WellEntity } from "@ots-frontend/ots-data";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseWellSelectProps = BaseEntitySelectProps<WellEntity>;

export const BaseWellSelect = (props: BaseWellSelectProps) => {
  return <BaseEntitySelect {...props} />;
};
